import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_WORKSPACE_KEY_VALUES: TypedDocumentNode<Data, Variables> = gql`
  query workspaceKeyValues($sort: WorkspaceKeyValueSortInput) {
    workspaceKeyValues(sort: $sort) {
      errorMessage
      id
      keyValue {
        id
        name
        tooltip
        type
      }
      status
      updatedAt
    }
  }
`
